import { Active, Application } from './enum';
export const DEBOUNCE_TIME_SELECTS = 700;
export const DEBOUNCE_TIME_SEARCH_FIELDS = 600;

export const ACTIVE_OPTIONS_LIST = [Active.active, Active.inactive];

export const APPLICATIONS_LIST_NO_VI = [
  Application.assetIntelligence,
  Application.fleetIntelligence,
  Application.safetyIntelligence,
  Application.businessIntelligence,
];
